import { styled, Typography } from '@mui/material';
// Types
import { IBusiness } from '@trii/types/dist/Contacts';
import { isBusiness } from '../../types/is-business.typeguard';
import { MemberItem } from './components';

const SectionTitle = styled(Typography)({
  fontWeight: 'bold',
  marginBottom: '8px',
  marginTop: '16px',
  borderBottom: `1px solid lightgray`,
});

interface MembersSectionProps {
  contactData?: IBusiness;
  title: string;
  navigate: (path: string) => void;
}

const MembersSection = ({ contactData, title, navigate }: MembersSectionProps) => {
  if (!contactData || !isBusiness(contactData) || !contactData.members?.length)
    return null;

  return (
    <>
      <SectionTitle gutterBottom mt={2} variant="subtitle1">
        {title}
      </SectionTitle>
      {contactData?.members.map((member) => (
        <MemberItem
          key={member.id}
          memberId={String(member.id)}
          name={member.name}
          navigate={navigate}
        />
      ))}
    </>
  );
};

export default MembersSection;
